<div class="console-page">
  <div class="console-content">
    <app-page-header title="Registro de tarjeta" description="Crear orden para registro y validación de tarjeta."></app-page-header>
    <form [formGroup]="myForm" (ngSubmit)="generateOrder()">
      <app-console-section title="Configuración API">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="cr-apiKey">API Key</label>
            <input id="cr-apiKey" class="console-input" formControlName="apiKey" placeholder="Ingrese su API Key" />
            <span class="console-field__error" *ngIf="myForm.get('apiKey')?.hasError('required') && myForm.get('apiKey')?.touched">API Key es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-secret">Secret</label>
            <input id="cr-secret" class="console-input" formControlName="secret" placeholder="Ingrese su clave secreta" />
            <span class="console-field__error" *ngIf="myForm.get('secret')?.hasError('required') && myForm.get('secret')?.touched">Secret es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-environment">Ambiente</label>
            <select id="cr-environment" class="console-select" formControlName="environment">
              <option value="LOCAL">LOCAL</option>
              <option value="QA">QA</option>
              <option value="DEV">DEV</option>
            </select>
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Información de la orden">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="cr-orderNumber">Número de orden</label>
            <input id="cr-orderNumber" class="console-input" formControlName="orderNumber" placeholder="Número de orden" />
            <span class="console-field__error" *ngIf="myForm.get('orderNumber')?.hasError('required') && myForm.get('orderNumber')?.touched">Número de orden es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-expirationDate">Fecha de expiración</label>
            <input id="cr-expirationDate" type="date" class="console-input" formControlName="expirationDate" />
            <span class="console-field__error" *ngIf="myForm.get('expirationDate')?.hasError('required') && myForm.get('expirationDate')?.touched">Fecha de expiración es requerida</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-integrationMode">Integration mode</label>
            <select id="cr-integrationMode" class="console-select" formControlName="integrationMode">
              <option [ngValue]="null">—</option>
              <option [ngValue]="1">1</option>
            </select>
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Cliente">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="cr-customerIdentifier">Identifier</label>
            <input id="cr-customerIdentifier" class="console-input" formControlName="customerIdentifier" placeholder="Identifier" />
            <span class="console-field__error" *ngIf="myForm.get('customerIdentifier')?.hasError('required') && myForm.get('customerIdentifier')?.touched">Identifier es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-customerName">Nombre</label>
            <input id="cr-customerName" class="console-input" formControlName="customerName" placeholder="Nombre del cliente" />
            <span class="console-field__error" *ngIf="myForm.get('customerName')?.hasError('required') && myForm.get('customerName')?.touched">Nombre es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-customerLastName">Apellido</label>
            <input id="cr-customerLastName" class="console-input" formControlName="customerLastName" placeholder="Apellido del cliente" />
            <span class="console-field__error" *ngIf="myForm.get('customerLastName')?.hasError('required') && myForm.get('customerLastName')?.touched">Apellido es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-customerPhone">Teléfono</label>
            <input id="cr-customerPhone" class="console-input" formControlName="customerPhone" placeholder="Teléfono del cliente" />
            <span class="console-field__error" *ngIf="myForm.get('customerPhone')?.hasError('required') && myForm.get('customerPhone')?.touched">Teléfono es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-customerEmail">Email</label>
            <input id="cr-customerEmail" type="email" class="console-input" formControlName="customerEmail" placeholder="Email del cliente" />
            <span class="console-field__error" *ngIf="myForm.get('customerEmail')?.hasError('required') && myForm.get('customerEmail')?.touched">Email es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-customerDocumentType">Tipo de documento</label>
            <select id="cr-customerDocumentType" class="console-select" formControlName="customerDocumentType">
              <option value="DNI">DNI</option>
              <option value="CE">CE</option>
              <option value="PASSPORT">PASSPORT</option>
            </select>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-customerDocumentNumber">Número de documento</label>
            <input id="cr-customerDocumentNumber" class="console-input" formControlName="customerDocumentNumber" placeholder="Número de documento" />
            <span class="console-field__error" *ngIf="myForm.get('customerDocumentNumber')?.hasError('required') && myForm.get('customerDocumentNumber')?.touched">Número de documento es requerido</span>
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Dirección">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="cr-addressCountry">País</label>
            <select id="cr-addressCountry" class="console-select" formControlName="addressCountry">
              <option value="PER">Perú</option>
              <option value="COL">Colombia</option>
              <option value="MEX">México</option>
            </select>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-addressLevel1">Departamento / estado</label>
            <input id="cr-addressLevel1" class="console-input" formControlName="addressLevel1" placeholder="Departamento" />
            <span class="console-field__error" *ngIf="myForm.get('addressLevel1')?.hasError('required') && myForm.get('addressLevel1')?.touched">Departamento es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-addressLevel2">Provincia</label>
            <input id="cr-addressLevel2" class="console-input" formControlName="addressLevel2" placeholder="Provincia" />
            <span class="console-field__error" *ngIf="myForm.get('addressLevel2')?.hasError('required') && myForm.get('addressLevel2')?.touched">Provincia es requerida</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-addressLevel3">Distrito</label>
            <input id="cr-addressLevel3" class="console-input" formControlName="addressLevel3" placeholder="Distrito" />
            <span class="console-field__error" *ngIf="myForm.get('addressLevel3')?.hasError('required') && myForm.get('addressLevel3')?.touched">Distrito es requerido</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-addressLine1">Dirección</label>
            <input id="cr-addressLine1" class="console-input" formControlName="addressLine1" placeholder="Dirección completa" />
            <span class="console-field__error" *ngIf="myForm.get('addressLine1')?.hasError('required') && myForm.get('addressLine1')?.touched">Dirección es requerida</span>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="cr-addressZip">Código postal</label>
            <input id="cr-addressZip" class="console-input" formControlName="addressZip" placeholder="Código postal" />
            <span class="console-field__error" *ngIf="myForm.get('addressZip')?.hasError('required') && myForm.get('addressZip')?.touched">Código postal es requerido</span>
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Idioma">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="cr-language">Idioma</label>
            <select id="cr-language" class="console-select" formControlName="language">
              <option value="es_PE">Español (Perú)</option>
              <option value="es_CO">Español (Colombia)</option>
              <option value="es_MX">Español (México)</option>
              <option value="en_US">English (US)</option>
            </select>
          </div>
        </div>
      </app-console-section>

      <div class="console-actions">
        <button class="console-btn console-btn--primary" type="submit" [disabled]="!myForm.valid || isLoading">
          <ng-icon *ngIf="isLoading" name="lucideLoader2" size="16" class="console-btn__icon console-btn__icon--spin"></ng-icon>
          <ng-icon *ngIf="!isLoading" name="lucideShoppingCart" size="16" class="console-btn__icon"></ng-icon>
          {{ isLoading ? 'Creando orden…' : 'Crear orden' }}
        </button>
        <button class="console-btn" type="button" (click)="resetForm()">
          <ng-icon name="lucideRefreshCw" size="16" class="console-btn__icon"></ng-icon>
          Resetear
        </button>
      </div>
    </form>

    <app-console-section *ngIf="orderLink || errorMessage" title="Resultado">
      <div *ngIf="orderLink" class="console-result console-result--success">
        <p><strong>Link de registro de tarjeta</strong></p>
        <div class="console-field__order-id">
          <input class="console-input" [value]="appendCardRegisteredQuery(orderLink)" readonly />
          <app-copy-button [value]="appendCardRegisteredQuery(orderLink)" ariaLabel="Copiar link"></app-copy-button>
        </div>
        <button class="console-btn console-btn--primary" type="button" (click)="openCardRegisterModal()">
          <ng-icon name="lucideExternalLink" size="16" class="console-btn__icon"></ng-icon>
          Abrir registro de tarjeta
        </button>
      </div>
      <div *ngIf="errorMessage" class="console-result console-result--error">
        <p>{{ errorMessage }}</p>
      </div>
    </app-console-section>
  </div>
</div>
